import React from 'react';
import { createRoot } from 'react-dom/client';
import { FaqComponent } from './FaqComponent';
import { FaqResponse } from './Faq.model';
import { get } from '../../util/ApiWrapper';

type Categories = FaqResponse['categories'];

/**
 * The fancy autocomplete faq.
 */
export class FAQ {

  constructor() {
    let resizeTimer: ReturnType<typeof setTimeout>;
    const postID: number = $('[data-module="faq"]').data('post');

    this.fetchResults(postID);

    // Bind to the window resize event so we can switch between
    // mobile and desktop view.
    $(window).on('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this.fetchResults(postID), 250);
    });
  }

  /**
   * Get the results from the localstorage or else from the backend.
   */
  public async fetchResults(postID: number): Promise<void> {
    const url: string = window.location.origin + '/wp-json/acf/v3/posts/' + postID + '/categories/';

    try {
      const response: FaqResponse = await get<FaqResponse>(url);
      this.renderFaq(response.categories);
    } catch (e) {
      //
    }
  }

  /**
   * Render the React component.
   */
  public renderFaq(results: Categories): void {
    const root = createRoot($('[data-container="faq-container"]')[0]);
    root.render(
        <>
          <FaqComponent categories={results}/>
        </>
    );
  }
}

